// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"1b587157","213":"5291b522","285":"680bb9b3","453":"b7d8d32a","847":"4034fb69","892":"a1e7f2cf","961":"f93339d0"}[chunkId] + ".chunk.js";
};